import { Component, OnDestroy, OnInit } from '@angular/core';
import { JobsDataServiceProvider } from '@services/job/jobs.data.service';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { ExportLeadsJobsResponse } from '@models/models';
import { SettingsProvider } from '@services/settings/settings';

@Component({
	selector: 'export-jobs-modal',
	template: require('./export-jobs-modal.html')
})
export class ExportJobsModalComponent implements OnInit, OnDestroy {
	private exportJobsModalRef: NgbModalRef;
	private unsubscribe = new Subject();

	statusDescription: string;
	exportAvailable: boolean;

	constructor(
		private jobsDataServiceProvider: JobsDataServiceProvider,
		private modalService: SNModalService,
		private messageService: MessageService,
		private settingsService: SettingsProvider
	) {}

	ngOnInit(): void {
		this.getPaymentExportState();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	exportJobs(content): void {
		this.jobsDataServiceProvider
			.getJobsExport()
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				(data: ExportLeadsJobsResponse) => {
					if (data.exportState === 'EXPORTING_HAS_BEEN_STARTED') {
						this.statusDescription =
							'Preparing to start your export! This may take up to an hour.';
						this.openModal(content);
					} else if (data.exportState === 'EXPORTING_IN_PROGRESS') {
						this.statusDescription = `Exporting in progress (${
							data.percentageComplete
						}% complete)...`;
						this.openModal(content);
					} else if (data.exportState === 'EXPORTING_IN_QUEUE') {
						this.statusDescription =
							"We're moving heaven and earth to make sure your export is next.";
						this.openModal(content);
					}
				},
				error => {
					const { errorTitle, errorMessage } = error.error;
					this.messageService.showErrorFromBackend(errorTitle, errorMessage);
				}
			);
	}

	private openModal(content) {
		this.exportJobsModalRef = this.modalService.openModal(content, {
			windowClass: 'ng-bootstrap-modal__small leads-jobs-width'
		});
	}

	private getPaymentExportState(): void {
		this.settingsService.timeFormatSettings
			.pipe(
				takeUntil(this.unsubscribe),
				filter((data): boolean => !!data),
				map((data): boolean => data.jobExportAvailable)
			)
			.subscribe(
				(exportState: boolean): boolean => (this.exportAvailable = exportState)
			);
	}

	onDismiss(): void {
		this.exportJobsModalRef.close();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/jobs/modals/export-jobs-modal/export-jobs-modal.ts